<template>
  <div class="DownloadFinish">
    <section-header heading="2" ja="ダウンロードに成功しました" />
    <!-- 無料会員 -->
    <template v-if="membershipGrade === 1 && sheets && sheets.length > 0">
        <div class="puriTopWrapper --marginTop">
            <puri-contents-top
              :selected-contents=selectedContents
              :membership-grade=membershipGrade
              :limit-date=limit
              :create-date=create
              :arcade-logo-img=arcadeLogoImg
            />
        </div>
    </template>
    <!-- 有料会員 -->
    <template v-else-if="membershipGrade >= 2 && sheets && sheets.length > 0">
      <div v-for="(sheet, i) in sheetsList" :key="i">
          <puri-sheet
            v-for="s in sheet"
            :key="s.id"
            :arcade-name=s.arcadeName
            :create-date=s.createDate
            :limit-date=s.limitDate
            :puri-list=s.puriList
            :arcade-logo-img=s.arcadeLogoImg
            :membership-grade=membershipGrade />
      </div>
    </template>

    <p class="smallText">
        ダウンロードできたプリクラは「アルバム」に追加されます。
    </p>
    <normal-btn @click="onAlbum">アルバムを見る</normal-btn>
    <p v-if="membershipGrade === 1" class="smallText --moreMarginTop">
        残りのプリクラは有料会員になるとダウンロードできます<br>
        保存期間が過ぎたプリクラはダウンロードできなくなります
    </p>

    <template v-if="membershipGrade === 1">
        <div class="puriBottomWrapper">
            <div class="gimmiTopWrapper">
                <div class="guidance">
                    <normal-btn @click="onMemberBenefits">詳しく見る</normal-btn>
                </div>
                <div class="limit">
                    <div class="limit__header">
                        <div class="limit__headerIcon" />
                        <span class="limit__headerText">保存期間</span>
                    </div>
                    <div v-if="limit" class="limit__remainingDay">
                        <span class="limit__remainingDaytext">残り{{ limitDateStr }}日</span>
                    </div>
                </div>
            </div>
            <div class="gimmiBottomWrapper">
                <puri-contents-bottom v-if="sheets && sheets.length > 0"
                    :contents=contents
                    :not-selected-contents="notSelectedContents"
                />
            </div>
        </div>
    </template>
    <sub-btn @click="onBack">プリダウンロードに戻る</sub-btn>
    <Dialog v-if="dialogOpen">
      <div class="dialogText">
        <p>シールID</P>
        <p>{{id}}</P>
        <p>一部のプリがモーメントのデータ生成に失敗しました</P>
        <p>失敗したプリはモーメントの再生、保存をご利用いただけません</P>
        <p>申し訳ございません</P>
        <p>FAQはこちら</P>
        <p>お問い合わせはこちら</P>
      </div>
      <normal-btn @click="dialogOpen = false">閉じる</normal-btn>
    </Dialog>
    <Dialog v-if="isOkOpenDialog">
      <div class="dialog-wrapper">
        <p v-if="hasReceivePitCoupon" class="dialog-text">既にクーポンを受け取り済みです。</p>
        <div v-else class="dialog-text --normalwrap">
          <template v-for="(list, i) in informationList">
            <div :key="i" class="pitInfoWrapper">
              <p v-if="list !== ''" v-html="list" class="pitInfoText"></p>
              <img v-if="imagePathList[i] !== ''" class="pitInfoImage" :width="pitImageWidthInfo[i]" :src="getImg(imagePathList[i])" alt="">
            </div>
          </template>
        </div>
      </div>
      <button class="closeBtn" @click="closePitDialog()"></button>
      <normal-btn v-if="dialogType !== 0 && !hasReceivePitCoupon && checkIOS() === false" id="onPitButton" @click="onPit">Prize ONを開く</normal-btn>
      <normal-btn v-if="dialogType !== 0 && !hasReceivePitCoupon && checkIOS()" class="appStoreButton" @click="onPitInstall">Prize ONをインストールする</normal-btn>
      <normal-btn v-if="dialogType !== 0 && !hasReceivePitCoupon && checkIOS()" @click="onPitIos">Prize ONを開く</normal-btn>
      <p v-if="dialogType !== 0 && !hasReceivePitCoupon && checkIOS()" class="onPitCaution">インストールがお済みの方はこちら</p>
      <normal-btn v-if="dialogType === 0 && !hasReceivePitCoupon" @click="closePitDialog()">閉じる</normal-btn>
    </Dialog>
  </div>
</template>

<script>
import SectionHeader from '../components/SectionHeader.vue'
import NormalBtn from '../components/NormalBtn.vue'
import SubBtn from '../components/SubBtn.vue'
import PuriSheet from '../components/PuriSheet'
import Protobuf from '../mixins/protobuf'
import { isIOS, isAndroid } from '../assets/js/util';
import PuriContentsTop from '@/components/PuriContentsTop.vue';
import PuriContentsBottom from '@/components/PuriContentsBottom.vue';
import {daysLeft, splitArray} from "../assets/js/util";

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web
const pbc = require('../assets/js/kumaproto').kuma.jp.protobuf.common
const ROW_MAX = 10

export default {
  name: "DownloadFinish",
  components: { SectionHeader, PuriSheet, NormalBtn, PuriContentsTop, PuriContentsBottom, SubBtn },
  mixins: [Protobuf],
  props: {
    id: {
      type: Number,
      default: 0,
    },
    limit: {
      type: Number,
      default: 0,
    },
    arcade: {
      type: String,
      default: "",
    },
    create: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      sheets: [],
      membershipGrade: -1,
      dialogOpen: false,
      isOkOpenDialog: false,
      informationList: null,
      imagePathList: null,
      informationToPit: null,
      imagePathToPit: null,
      bannerImagePath: null,
      buttonUrl: '',
      dialogType: 0,
      campId: 1,
      logoUrl: [],
      logoList: [],
      pitImageWidthInfo: [], // PIT連携ダイアログ内の画像の横幅を格納
      contents: [],
      tmpContents: [],
      selectedContents: [],
      notSelectedContents: [],
      arcadeLogoImg: '',
    }
  },
  methods: {
    onBack() {
      this.$router.push('/download')
    },
    onAlbum() {
      this.$router.push('/album')
    },
    onMemberBenefits() {
      this.$router.push('/MemberBenefits')
    },
    onPit(){
      if(isAndroid()){
        location.href = this.buttonUrl
        setTimeout(() => {
          location.href = 'https://play.google.com/store/apps/details?id=com.sega.pit'
        }, 3000)
      } else {
        this.$router.push('/EnvironmentAttention')
      }
    },
    onPitIos(){
      location.href = this.buttonUrl
    },
    onPitInstall(){
      location.href = 'https://apps.apple.com/jp/app/prize-on/id1571601446'
    },
    checkIOS(){
      return isIOS()
    },
    closePitDialog() {
      this.isOkOpenDialog = false
      this.setDialogInfo(this.campId, false, this.dialogType)
    },
    getImg(img) {
      return process.env.VUE_APP_STATIC_CONTENT_SERVER_URL + img
    },
    async getPitInfo(){
      const cmdNo = pb.PlayerCampPitInfoReq.CommandNo.COMMAND_NO
      const message = pb.PlayerCampPitInfoReq.create()
      const encoded = pb.PlayerCampPitInfoReq.encode(message).finish()

      this.post(cmdNo, encoded)
        .then(decoded => {
            if (decoded.status === pb.PlayerCampPitInfoResp.Status.SUCCESS) {
              this.informationList = decoded.informationList
              this.imagePathList = decoded.imagePathList
              this.informationToPit = decoded.informationToPit
              this.imagePathToPit = decoded.imagePathToPit
              this.bannerImagePath = decoded.bannerImagePath
              this.buttonUrl = decoded.buttonUrl
              this.dialogType = decoded.dialogType
              this.campId = decoded.campId

              this.isOkOpenDialog = decoded.isOkOpenDialog

              // 対象のキャンペーンのダイアログ情報を取得
              const targetDialogInfo = JSON.parse(localStorage.getItem(`dialogInfo${decoded.campId}`))

              if(decoded.dialogType < 0 || decoded.dialogType > 2){
                // クーポン受け取り資格がないのでダイアログは非表示
                this.isOkOpenDialog = false
              } else if(targetDialogInfo === null && decoded.dialogType >= 0 && decoded.dialogType <= 2){
                // 初めてダイアログを表示する場合
                this.setDialogInfo(decoded.campId, decoded.isOkOpenDialog, decoded.dialogType)
              } else if(targetDialogInfo && targetDialogInfo.dialogType === decoded.dialogType){
                // ダイアログの種類（キャンペーン期間）が変わっていないのでlocalstorageの中身維持
                this.isOkOpenDialog = targetDialogInfo.isOkOpenDialog
              } else if(targetDialogInfo && targetDialogInfo.dialogType !== decoded.dialogType && decoded.dialogType >= 0 && decoded.dialogType <= 2){
                // ダイアログの種類（キャンペーン期間）が変わったので再度セット
                this.setDialogInfo(decoded.campId, decoded.isOkOpenDialog, decoded.dialogType)
              } else {
                this.setDialogInfo(decoded.campId, decoded.isOkOpenDialog, decoded.dialogType)
              }
              this.setPitImageSize(decoded.imagePathList)

              this.getMembershipGrade()
            }
        })
    },
    setDialogInfo(campId, isOkOpenDialog, dialogType){
      const dialogInfo = {
        'isOkOpenDialog': isOkOpenDialog,
        'dialogType': dialogType,
      }
      localStorage.setItem(`dialogInfo${campId}`, JSON.stringify(dialogInfo))
    },
    // PIT連携ダイアログ内の画像のサイズ調整
    async setPitImageSize(imagePathList){
      let imagesInfo = []
      for (let i = 0; i < imagePathList.length; i++) {
        if(imagePathList[i] === ''){
          imagesInfo.push('')
          continue;
        }else {
          const imageRes = await this.getImageInfo(imagePathList,i)
            .then(res => res)
          if(imageRes && imageRes.naturalWidth >= 800){
            imagesInfo.push(imageRes.naturalWidth)
          } else if(imageRes && imageRes.naturalWidth < 800){
            // 横幅800px未満の画像はアプリ側の表示に合わせるためサイズを小さく
            const halfWidth = imageRes.naturalWidth / 2.8
            imagesInfo.push(halfWidth)
          } else {
            imagesInfo.push('')
          }
        }
      }
      // PIT連携画像の横幅をまとめて格納
      Promise.all(imagesInfo).then(res => {
        this.pitImageWidthInfo = res;
      })
    },
    // 画像の情報を取得
    async getImageInfo(imagePathList, i){
      return new Promise((resolve, reject) => {
        const targetSrc = this.getImg(imagePathList[i])
        const img = new Image()
        img.src = targetSrc
        img.onload = () => {
          resolve(img)
        }
        img.onerror = (error) => {
          reject(error)
        }
      })
    },
    getLogoList() {
      const cmdNo = pb.KumaMasterSettingReq.CommandNo.COMMAND_NO
      const message = pb.KumaMasterSettingReq.create()
      const encoded = pb.KumaMasterSettingReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          this.logoList = decoded.masterArcadeList
        })
    },
    getSheetInfo() {
      this.sheets = []
      const cmdNo = pb.PuriContentListReq.CommandNo.COMMAND_NO
      const message = pb.PuriContentListReq.create({
          id: this.$store.state.targetPuriId
      })
      const encoded = pb.PuriContentListReq.encode(message).finish()
      return this.post(cmdNo, encoded)
        .then(decoded => {
          const targetArcade = this.logoList.find(item => item.name === this.arcade)
          if(targetArcade && targetArcade.arcadeLogoImg){
              this.sheets.push({
                  id: this.$store.state.targetPuriId,
                  arcadeName: this.arcade,
                  createDate: this.create,
                  limitDate: this.limit,
                  puriList: decoded.puriList,
                  arcadeLogoImg: targetArcade.arcadeLogoImg
              })
          }
          if(this.membershipGrade === 1) this.getPuriLists()
        }).catch(() => {
            this.$_error('Error', { title: 'プリダウンロード', statusCode: 420 })
        })
    },
    // ユーザーの会員情報取得
    getMembershipGrade(){
      const cmdNo = pb.PlayerInfoReq.CommandNo.COMMAND_NO
      const message = pb.PlayerInfoReq.create()
      const encoded = pb.PlayerInfoReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          this.membershipGrade = decoded.membershipGrade
          if(this.$store.state.targetPuriId && this.membershipGrade){
            this.getSheetInfo()
          } else {
            this.$router.push('/download')
          }
      })
    },
    async getPuriLists(){
      const requests = []
      const image = pbc.PuriContentType.THUMBNAIL
      const imageBase = pbc.PuriContentType.THUMBNAIL_BASE
      const cmdNo = pb.PuriContentReq.CommandNo.COMMAND_NO

      if(this.sheets.length > 0 && this.sheets[0].puriList.length > 0){
        const puriList = this.sheets[0].puriList;
        puriList.forEach(d => {
          let types;
          if(d.surpriseShot2){
            types = imageBase
          } else {
            types = image
          }
          const message = pb.PuriContentReq.create({
            id: d.id,
            types: [types]
          })
          const encoded = pb.PuriContentReq.encode(message).finish()
          requests.push(this.post(cmdNo, encoded))
        })
        const decodes = await Promise.all(requests)

        decodes.forEach((d, i) => {
          let bytes;
          if(puriList[i].surpriseShot2){
            // プリもっと2枚目は加工無し画像
            bytes = d.contents[imageBase]
          } else {
            // その他は加工あり画像
            bytes = d.contents[image]
          }
          this.tmpContents.push({
            bytes: bytes,
            selected: puriList[i].selected || !this.$store.getters.isFreeMembership,
            seqIndex: puriList[i].seqIndex,
            hasgraff: d.hasgraff,
            surpriseShot: puriList[i].surpriseShot,
            surpriseShot2: puriList[i].surpriseShot2
          })
        })
      }
    },
    toNewList(contents) {
      const arr = contents
      return splitArray(arr, 30)
    },
  },
  watch: {
    tmpContents(v) {
        if (v.length === this.sheets[0].puriList.length) {
            this.contents = v.concat().sort((a, b) => a.seqIndex - b.seqIndex)
            this.selectedContents = this.contents.filter(element => element.selected)
            this.notSelectedContents = this.contents.filter(element => !element.selected)
        }
    }
  },
  computed: {
    sheetsList() {
      const arr = this.sheets
      arr.sort((a, b) => a.limitDate > b.limitDate ? 1 : -1)
      return splitArray(arr, ROW_MAX)
    },
    limitDateStr() {
      return daysLeft(this.limit)
    }
  },
  created() {
    this.getLogoList()
    // データがない場合は/downloadに戻る
    if(!this.id || !this.create || !this.limit || !this.arcade) {
      this.$router.replace('/download')
      return
    }
  },
  mounted() {
    this.getPitInfo()
  }
}
</script>

<style lang="scss" scoped>
.description {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
}
.sheets {
  margin-top: 20px;
  .card {
    border: none !important;
    background-color: #fff;
  }
}
.dialog {
  .dialogText {
    font-size: 12px;
    color: #373737;
  }
  &-wrapper {
    width: 100%;
    height: 400px;
    margin-top: 20px;
    color: #373737;
    overflow-y: scroll;
  }
  &-text {
    margin-top: 5px;
    font-size: 12px;
    color: 373737;
    white-space: pre;

    .pitInfoWrapper {
      width: 90%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
        .pitInfoText {
          width: 100%;
        }
        .pitInfoImage {
          max-width: 100%;
        }
      }
  }
  .--normalwrap {
    white-space: normal;
  }
  .NormalBtn { margin: 20px 0 0; }
  .appStoreButton {
    margin-top: 15px;
  }
  .onPitCaution {
    font-size: 14px;
    text-align: center;
  }
}

.puriTopWrapper {
    display: flex;
    justify-content: center;
    margin: 0 15px;
}
.--marginTop {
    margin-top: 25px;
}

.NormalBtn {
    margin-top: 15px;
}
.smallText {
    margin: 15px 15px 0;
    font-size: 12px;
}

.--moreMarginTop {
  margin-top: 30px;
}

.puriBottomWrapper {
    width: calc(100% - 30px);
    display: flex;
    height: fit-content;
    margin: 20px auto;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    .gimmiTopWrapper,
    .gimmiBottomWrapper {
        margin: 0 auto;
    }
    .gimmiTopWrapper {
        width: 100%;
        .guidance {
            width: 100%;
            margin: 0;
            text-align: center;
            &__text {
                font-size: 12px;
            }
            .NormalBtn {
                margin: 0;
            }
        }
        .limit {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 20px;
          &__header {
              display: flex;
              justify-content: center;
              align-items: center;
              color: #F63C5B;
          }
          &__headerIcon {
              width: 18px;
              height: 18px;
              background-image: url(../assets/Png/Common/ic_exclamation_pink.png);
              background-size: contain;
              background-position: 0;
          }
          &__headerText {
              font-size: 12px;
              margin-left: 5px;
          }
          &__remainingDaytext {
              font-size: 28px;
              color: #F63C5B;
              margin-left: 40px;
          }
        }
    }
}
</style>
